<template>
	<div class="itemWrapper">
		<img class="avatarImg" :src="sectionData.avatar"/>
		<div class="rightZone">
			<div class="topActionWrapper">
				<div>
					<div class="floorHostName">{{sectionData.username}}</div>
					<div class="stars">
						<img class="starIcon" v-for="val of starArr" :src="val ? iconSource.starActive : iconSource.starInactive" :key="'' + val + Math.random()" />
					</div>
				</div>
				<div class="time">{{formatTime(sectionData.createdtime)}}</div>
			</div>
			<div class="commentContent" :class="{lessMargin: !starArr.length}">{{sectionData.content}}</div>
		</div>
	</div>
</template>

<script>
	import utils from '@/utils/utils'
	export default {
		props: {
			sectionData: {
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		data(){
			return {
				iconSource: {
					starActive: require('../../assets/image/course/star_small_active.png'),
					starInactive: require('../../assets/image/course/star_small_inactive.png')
				}
			}
		},
		computed: {
			starArr(){
				let rating = Math.round(Number(this.sectionData.rating))
				if(Number.isNaN(rating)){
					return []
				}else{
					return Array.from({length: 5}, (v, i) => {
						return (i + 1 <= rating) ? true : false
					})
				}
			}
		},
		methods: {
			formatTime(dateline){
				if(+dateline){
					let date = null
					if(dateline.toString().length == 10){
						date = new Date(dateline * 1000)
					}else{
						date = new Date(+dateline)
					}
					let month = utils.padZero(date.getMonth() + 1, 2),
					day = utils.padZero(date.getDate(), 2)
					let timeString = month + '月' + day + '日'
					return timeString
				}else{
					return ""
				}
			}
		}
	}
</script>

<style scoped>
.itemWrapper{
	display: flex;
	margin: 0 15px;
	padding: 15px 0;
	background-color: #fff;
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.avatarImg{
	width: 35px;
	height: 35px;
	overflow: hidden;
	border-radius: 18px;
	background-color: #d8d8d8;
}
.rightZone{
	flex: 1;
	margin-left: 10px;
}
.topActionWrapper{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.floorHostName{
	flex: 1;
	margin-right: 7px;
	margin-bottom: 3px;
	font-size: 14px;
	color: #4a4a4a;
}
.stars{
	display: flex;
	align-items: center;
}
.time{
	font-size: 12px;
	color: #999;
}
.commentContent{
	font-size: 18px;
	color: #3f454b;
	margin-top: 10px;
}
.starIcon{
	width: 11px;
	height: 11px;
}

.lessMargin{
	margin-top: 5px;
}
</style>